import * as autocompletion from '../../helpers/autocompletion';
import Replacement from './format';
import { ALL_CHOICES, TRIGGERS } from './replacements';

const NAME = 'replacements';

const STYLE = { minWidth: '220px' };

function Choice(props) {
    return (
        <autocompletion.ResultsItem {...props} style={STYLE}>
            {props.item.label}
        </autocompletion.ResultsItem>
    );
}

class Replacements {
    constructor(quill) {
        const container = quill.addContainer('ql-replacement');
        this.instance = autocompletion.createInstance({
            quill,
            container,
            wrapperComponent: autocompletion.ResultsContainer,
            itemComponent: Choice,
            moreItemsComponent: autocompletion.ResultsMoreItems,
            maxItemsShown: Infinity,
            itemToKey: item => item.value,
            onSearch: query => Promise.resolve(query.trigger ? query.trigger.choices : ALL_CHOICES),
            onSelect: (item, query) => {
                this.instance.hide();
                autocompletion.replaceQueryWithEmbed(quill, query, Replacement.blotName, {
                    value: item.value,
                    serialization: item.replacement,
                });
            },
        });

        this.instance.listen(TRIGGERS);
    }

    openAtIndex = index => this.instance.openAtIndex(index);
}

export const name = NAME;
export const handler = Replacements;
export const formats = [Replacement];

export const toolbarElements = [
    {
        key: 'replacements',
        type: 'insertDropdown',
        onClick: ({ quill, getLastSelection }) => {
            const lastSelection = getLastSelection();
            quill.setSelection(lastSelection);
            quill.getModule(NAME).openAtIndex(lastSelection.index);
        },
        label: <span>Replacements</span>,
    },
];
